import React from "react"
import {
  Document, Page, Text, View, StyleSheet,
} from "@react-pdf/renderer"

const pdfStyles = StyleSheet.create({
  page: { padding: "32px 28px", backgroundColor: "#ffffff" },
  header: {
    borderBottom: 1,
    borderColor: "#e5e7eb",
    paddingBottom: 12,
    marginBottom: 20,
    alignItems: "center",
  },
  headerTitle: { fontSize: 14, color: "#1a1a2e", textAlign: "center" },
  headerSubtitle: {
    fontSize: 10,
    color: "#5C6D7D",
    marginTop: 2,
    textAlign: "center",
  },
  messageRow: { marginBottom: 12 },
  userRow: { alignItems: "flex-end" },
  botRow: { alignItems: "flex-start" },
  userBubble: {
    backgroundColor: "#d9eef7",
    borderRadius: 12,
    padding: "8px 12px",
    maxWidth: "75%",
  },
  botBubble: {
    backgroundColor: "#f3f4f6",
    borderRadius: 12,
    padding: "8px 12px",
    maxWidth: "75%",
  },
  messageText: { fontSize: 11, color: "#1a1a2e", lineHeight: 1.5 },
})

const ChatPDFDocument = ({ messages }) => (
  <Document>
    <Page style={pdfStyles.page}>
      <View style={pdfStyles.header}>
        <Text style={pdfStyles.headerTitle}>Chat Conversation</Text>
        <Text style={pdfStyles.headerSubtitle}>
          Rei the Resilient Scholars Program Coach
        </Text>
      </View>
      {messages.map((message, index) => {
        const isUser = message.role === "user"
        const content = message.fullContent || message.content || ""
        return (
          <View
            key={index}
            wrap={false}
            style={[
              pdfStyles.messageRow,
              isUser ? pdfStyles.userRow : pdfStyles.botRow,
            ]}
          >
            <View style={isUser ? pdfStyles.userBubble : pdfStyles.botBubble}>
              <Text style={pdfStyles.messageText}>{content}</Text>
            </View>
          </View>
        )
      })}
    </Page>
  </Document>
)

export default ChatPDFDocument
